import { ComponentPublicInstance } from "vue";
import { DollarApollo } from "@vue/apollo-option/types/vue-apollo";
import DOCUMENTS_PREV_NEXT_QUERY from "@/graphql/document/PrevNextDocument.gql";
import FILTER_DOCUMENTS_SHORT from "@/graphql/document/FilterDocumentsShort.gql";

const DOCUMENT_AWAITING_STATUS = [
    "ORIGINAL_UPLOADED",
    "UPLOADED",
    "ANALYSED",
    "ANALYSED_OK",
    "PENDING",
    "ERROR",
];

/**
 * Return true if the current document is not validated it's allow to display a button
 * to enable/disable the option to switch directly to the next no validated document
 */
export function isNoValidatedDocument(documentStatus: string): boolean {
    return DOCUMENT_AWAITING_STATUS.includes(documentStatus);
}

/**
 * Return the id of the next no validated document
 * "_" if all documents are validated
 * null in case of error
 */
export async function getNextNoValidatedDocumentId(
    apollo: DollarApollo<ComponentPublicInstance>,
    queryParams,
): Promise<string | null> {
    let nextNoValidatedDocumentId = "_";

    queryParams.where.status_in = DOCUMENT_AWAITING_STATUS;

    const prevNextDocumentRequestResponse = await apollo.query({
        query: DOCUMENTS_PREV_NEXT_QUERY,
        variables: queryParams,
    });

    if (
        !prevNextDocumentRequestResponse?.data?.nextDocumentId ||
        !prevNextDocumentRequestResponse?.data?.previousDocumentId
    ) {
        return null;
    }

    const nextNoValidatedDocuments = prevNextDocumentRequestResponse.data.nextDocumentId;

    if (nextNoValidatedDocuments.length) {
        nextNoValidatedDocumentId = nextNoValidatedDocuments[0]?.id;
    } else {
        // restart to the begining of the list
        const filterDocumentsShortRequestResponse = await apollo.query({
            query: FILTER_DOCUMENTS_SHORT,
            variables: queryParams,
        });
        if (!filterDocumentsShortRequestResponse?.data?.documents) {
            return null;
        }
        const noValidatedDocuments = filterDocumentsShortRequestResponse.data.documents;
        if (noValidatedDocuments?.length) {
            nextNoValidatedDocumentId = filterDocumentsShortRequestResponse.data.documents[0]?.id;
        }
    }

    return nextNoValidatedDocumentId;
}
